import * as React from "react";
import { Button } from "components/button";
import { useSnackbarContext } from "components/snackbar";
import { useTranslation } from 'react-i18next';

const INVALID_CHARACTERS_REGEX = /[\/:*?"<>|]/;

const EditFileModal = ({ oldKey, newKey, editFile, setModal, ext, isLoading, files }: any) => {
  const { t } = useTranslation();
  const tBase = "components.file-grid.EditFileModal";
  const tr = (key: string) => t(`${tBase}.${key}`);
  const [value, setValue] = React.useState(newKey.replace(`.${ext}`, ""));
  const [isError, setIsError] = React.useState(false);
  const { showSnackbar } = useSnackbarContext();

  const handleSave = () => {
    const finalName = `${value}.${ext}`;

    if (finalName === newKey) {
      setModal();
      return;
    }

    if (!value.trim()) {
      showSnackbar(tr("File name cannot be empty"));
      setIsError(true);
      setTimeout(() => setIsError(false), 500); // Remove shake effect after animation
      return;
    }

    if (INVALID_CHARACTERS_REGEX.test(value)) {
      showSnackbar(tr("A file name can't contain any of the following characters") + `: \\ / : * ? \" < > |`);
      setIsError(true);
      setTimeout(() => setIsError(false), 500);
      return;
    }
    
    //ensure file name is unique to other files
    const exists = files.find((file: any) => file.name === `${value}.${ext}`);
    if (exists) {
      showSnackbar(tr("File with that name already exists"));
      setIsError(true);
      setTimeout(() => setIsError(false), 500); // Remove shake effect after animation
      return;
    }

    editFile({ oldKey, newKey: finalName });
  };

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex items-center w-full rounded">
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={oldKey.replace(`.${ext}`, "")}
          className={`ml-2
            border border-gray-300 p-1 flex-grow w-full rounded-s 
           ${isError ? "border-red-400 animate-shake" : " focus:outline-blue-300"}
          `}
        />
        <div className="border border-gray-300 p-1 bg-gray-300 rounded-e">
          .{ext}
        </div>
      </div>

      <div className="flex justify-end space-x-4">
        <Button 
          type="secondary"
          onClick={() => setModal()}
        >
          {tr("Cancel")}
        </Button>
        <Button
          isLoading={isLoading}
          primary
          onClick={handleSave}
        >
          {tr("Save")}
        </Button>
      </div>
    </div>
  );
};

export default EditFileModal;